export default "__VITE_ASSET__BNc$3cgB__"